document.addEventListener('DOMContentLoaded', function () {

    // KEAMANAN: API Key ini terekspos di client-side.
    // WAJIB restrict di Google Cloud Console:
    // 1. Restrict HTTP Referrer ke domain Anda saja
    // 2. Restrict hanya ke YouTube Data API v3
    // https://console.cloud.google.com/apis/credentials
    var API_KEY = 'AIzaSyBKkCRWuS9XNOk-ovIvsioVw0xhPdgll3E';
    var CHANNEL_ID = 'UCPnJhWZMQ-bbOOi71K4Kg6w';

    // ==========================================

    var container = document.getElementById('yt-widget-container');
    var titleElem = document.getElementById('main-video-title');
    var listDiv = document.getElementById('yt-playlist-results');

    if (!container) return;
    container.style.display = 'block';

    // Cek jika user lupa ganti
    if (API_KEY.includes('MASUKKAN') || CHANNEL_ID.includes('MASUKKAN')) {
        if (titleElem) {
            titleElem.textContent = 'ERROR: API Key belum diganti!';
            titleElem.style.color = 'red';
        }
        return;
    }

    // Logic Playlist
    var playlistId = CHANNEL_ID;
    if (CHANNEL_ID.startsWith('UC')) {
        playlistId = 'UU' + CHANNEL_ID.substring(2);
    }

    var apiUrl = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + encodeURIComponent(playlistId) + '&key=' + encodeURIComponent(API_KEY);

    fetch(apiUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
            if (data.error) {
                if (titleElem) titleElem.textContent = 'Gagal memuat video.';
                return;
            }
            if (!data.items || data.items.length === 0) {
                if (titleElem) titleElem.textContent = 'Tidak ada video.';
                return;
            }

            var items = data.items;
            var player = document.getElementById('main-yt-player');

            if (player && items[0].snippet && items[0].snippet.resourceId) {
                player.src = 'https://www.youtube.com/embed/' + encodeURIComponent(items[0].snippet.resourceId.videoId) + '?rel=0';
            }
            if (titleElem && items[0].snippet) {
                titleElem.textContent = items[0].snippet.title;
            }

            if (!listDiv) return;
            listDiv.innerHTML = '';

            items.forEach(function (item) {
                var s = item.snippet;
                if (!s || !s.resourceId) return;

                var vid = s.resourceId.videoId;

                // KEAMANAN: Gunakan DOM API, bukan innerHTML, untuk mencegah XSS
                var ytItem = document.createElement('div');
                ytItem.className = 'yt-item';
                ytItem.style.cssText = 'display:flex; gap:10px; padding:10px; border-bottom:1px solid #333; cursor:pointer;';
                ytItem.setAttribute('data-video-id', vid);
                ytItem.setAttribute('data-video-title', s.title || '');

                var img = document.createElement('img');
                if (s.thumbnails && s.thumbnails.default && s.thumbnails.default.url) {
                    img.src = s.thumbnails.default.url;
                }
                img.style.cssText = 'width:80px; height:45px; object-fit:cover;';
                img.alt = s.title || '';

                var textDiv = document.createElement('div');

                var h4 = document.createElement('h4');
                h4.style.cssText = 'font-size:13px; margin:0; color:#ddd;';
                h4.textContent = s.title || '';

                var span = document.createElement('span');
                span.style.cssText = 'font-size:11px; color:#888;';
                span.textContent = new Date(s.publishedAt).toLocaleDateString();

                textDiv.appendChild(h4);
                textDiv.appendChild(span);
                ytItem.appendChild(img);
                ytItem.appendChild(textDiv);

                // KEAMANAN: addEventListener, bukan inline onclick
                ytItem.addEventListener('click', function () {
                    var videoId = this.getAttribute('data-video-id');
                    var videoTitle = this.getAttribute('data-video-title');
                    var playerElem = document.getElementById('main-yt-player');
                    var titleEl = document.getElementById('main-video-title');

                    if (playerElem) {
                        playerElem.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1';
                    }
                    if (titleEl) {
                        titleEl.textContent = videoTitle;
                    }
                });

                listDiv.appendChild(ytItem);
            });
        })
        .catch(function () {
            if (titleElem) titleElem.textContent = 'Gagal memuat video.';
        });
});